/* eslint-disable no-param-reassign */
import axios from 'axios';
import Qs from 'qs';
import Cookies from 'js-cookie';

let baseURL = Cookies.get('api');

if (process.env.NODE_ENV === 'development') {
  baseURL = Cookies.get('api') || 'https://dev-order-api.ocard.co';
} else if (process.env.NODE_ENV === 'uat') {
  baseURL = Cookies.get('api') || 'https://uat-order-api.ocard.co';
} else {
  baseURL = 'https://api-order.ocard.co';
}

const Axios = axios.create({
  baseURL,
});

Axios.interceptors.request.use(
  (instance) => {
    const config = instance;

    let locale = (typeof (window.navigator.language || window.navigator.userLanguage) === 'string' && (window.navigator.language || window.navigator.userLanguage).includes('en')) ? 'en' : 'zh-Hant';

    if (typeof Cookies.get('ocard_order_lang') === 'string') {
      locale = Cookies.get('ocard_order_lang');

      config.params = {
        lang: locale,
      };
    }

    const utk = Cookies.get('utk') || null;

    if (utk) {
      config.headers.Authorization = `Bearer ${utk}`;
    }

    const dtk = Cookies.get('dtk') || null;

    if (dtk) {
      instance.data.dtk = dtk;
    }

    if (Cookies.get('p')) {
      instance.data.p = atob(Cookies.get('p'));
    }

    const s = Cookies.get('s') || null;

    if (s) {
      instance.data.s = s;
    }

    config.data = Qs.stringify(instance.data);

    return config;
  },
  (error) => Promise.reject(error),
);

export default Axios;
